<template>
    <div>
        <notifications position="top center" group="info" />

        <h1>Notification</h1>

        <p>Type
        <b-select v-model="type" :options="['primary', 'success', 'danger', 'warning']"></b-select>
        </p>

        <p>Titre
            <b-input v-model="title"></b-input>
        </p>

        <p>Texte
        <b-textarea v-model="text"></b-textarea>
        </p>

        <p v-if="!client_uid">Canal
        <b-input v-model="dest"></b-input>
        </p>

        <p>Actif
        <b-checkbox v-model="active"></b-checkbox>
        </p>

        <br />

        <b-button @click="send">Mettre à jour</b-button>
    </div>

</template>

<script>
	import store from "../store.js";
	import notifications_services from "../services/notifications.js";

	export default {
        name: "notification",
        components: {
        },
		data: function () {
			return {
				uid: this.$route.params.id,
                type: "danger",
                text: "",
                title: "",
                dest: "notification",
                active: false,
                client_uid: null
			};
		},
		methods: {
            async send()
            {
                await notifications_services.put(this.uid, this.type, this.title, this.text, this.dest, this.active);

                this.$notify({
					group: "info",
					title: "Notification enregistrée",
					type: "success",
                });

                this.notification = await notifications_services.get(this.$route.params.id);

                
            },
            isAdmin: function() {
                return store.getters.isAdmin;
            }
		},
		mounted: async function () {
            
            if (store.state.user.rules && !store.state.user.rules.notifications) {
                this.$router.push({ name: "profile" });
            }

            this.notification = await notifications_services.get(this.$route.params.id);
			
			this.uid = this.notification.uid;
			this.type = this.notification.data.type;
			this.text = this.notification.data.text;
			this.title = this.notification.title;
			this.dest = this.notification.dest;
            this.active = this.notification.active;
            this.client_uid = this.notification.client_uid;

            // this.resetActions();
		},
	};
</script>
